import { createAsyncThunk } from "@reduxjs/toolkit";
//Include Both Helper File with needed methods
import {
  getSalesSummaryCards as getSalesSummaryCardsApi,
  getSalesReferralLinkDetails as getSalesReferralLinkDetailsApi,
  addSalesReferralLinkDetailsForLanguage as addSalesReferralLinkDetailsForLanguageApi,
  getSalesNetworkChart as getSalesNetworkChartApi,
  getSalesRebateDetails as getSalesRebateDetailsApi,
} from "../../helpers/ServiceHelpers/backend_helper";

// Get Sales Summary Cards
export const getSalesSummaryCards = createAsyncThunk(
  "get/SalesSummaryCards",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesSummaryCardsApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
// Get Sales Referral Link Details
export const getSalesReferralLinkDetails = createAsyncThunk(
  "get/SalesReferralLinkDetails",
  async (id: number) => {
    try {
      const response = getSalesReferralLinkDetailsApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);
// Add Sales Referral Link Details
export const addSalesReferralLinkDetailsForLanguage = createAsyncThunk(
  "get/addSalesReferralLinkDetailsForLanguage",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = addSalesReferralLinkDetailsForLanguageApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Sales Network Chart
export const getSalesNetworkChart = createAsyncThunk(
  "get/SalesNetworkChart",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesNetworkChartApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Rebate Details
export const getSalesRebateDetails = createAsyncThunk(
  "get/SalesRebateDetails",
  async (id: number) => {
    try {
      const response = getSalesRebateDetailsApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);
